var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBank(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 78,
    viewBox: "0 0 100 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M94.3023 35.048H6.0874C3.74904 35.048 1.84827 33.1473 1.84827 30.8089V29.6329C1.84827 27.8825 2.79182 26.2553 4.3097 25.3801L46.8719 0.882013C48.9231 -0.294004 51.4666 -0.294004 53.511 0.882013L96.08 25.3801C97.5979 26.2553 98.5346 27.8825 98.5346 29.6329V30.8089C98.5346 33.1473 96.6339 35.048 94.2955 35.048H94.3023ZM50.1949 2.73492C49.518 2.73492 48.8411 2.90586 48.2394 3.25456L5.67033 27.7526C5.00027 28.1355 4.5832 28.8603 4.5832 29.6329V30.8089C4.5832 31.6362 5.26009 32.3131 6.0874 32.3131H94.3023C95.1297 32.3131 95.8065 31.6362 95.8065 30.8089V29.6329C95.8065 28.8603 95.3895 28.1355 94.7194 27.7526L52.1503 3.25456C51.5487 2.90586 50.8718 2.73492 50.1949 2.73492Z",
    fill: "#5630B5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12.1452 70.8277C11.3931 70.8277 10.7778 70.2123 10.7778 69.4602V38.371C10.7778 37.6189 11.3931 37.0035 12.1452 37.0035C12.8974 37.0035 13.5127 37.6189 13.5127 38.371V69.4602C13.5127 70.2123 12.8974 70.8277 12.1452 70.8277Z",
    fill: "#5630B5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M19.2903 70.8277C18.5382 70.8277 17.9229 70.2123 17.9229 69.4602V38.371C17.9229 37.6189 18.5382 37.0035 19.2903 37.0035C20.0424 37.0035 20.6578 37.6189 20.6578 38.371V69.4602C20.6578 70.2123 20.0424 70.8277 19.2903 70.8277Z",
    fill: "#5630B5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M46.619 70.8277C45.8669 70.8277 45.2515 70.2123 45.2515 69.4602V38.371C45.2515 37.6189 45.8669 37.0035 46.619 37.0035C47.3711 37.0035 47.9864 37.6189 47.9864 38.371V69.4602C47.9864 70.2123 47.3711 70.8277 46.619 70.8277Z",
    fill: "#5630B5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M53.7707 70.8277C53.0186 70.8277 52.4033 70.2123 52.4033 69.4602V38.371C52.4033 37.6189 53.0186 37.0035 53.7707 37.0035C54.5228 37.0035 55.1382 37.6189 55.1382 38.371V69.4602C55.1382 70.2123 54.5228 70.8277 53.7707 70.8277Z",
    fill: "#5630B5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M80.8601 70.8277C80.108 70.8277 79.4926 70.2123 79.4926 69.4602V38.371C79.4926 37.6189 80.108 37.0035 80.8601 37.0035C81.6122 37.0035 82.2275 37.6189 82.2275 38.371V69.4602C82.2275 70.2123 81.6122 70.8277 80.8601 70.8277Z",
    fill: "#5630B5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M88.005 70.8277C87.2529 70.8277 86.6375 70.2123 86.6375 69.4602V38.371C86.6375 37.6189 87.2529 37.0035 88.005 37.0035C88.7571 37.0035 89.3724 37.6189 89.3724 38.371V69.4602C89.3724 70.2123 88.7571 70.8277 88.005 70.8277Z",
    fill: "#5630B5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M98.2201 78.0001H1.77989C1.02779 78.0001 0.41243 77.3847 0.41243 76.6326C0.41243 75.8805 1.02779 75.2651 1.77989 75.2651H98.2201C98.9722 75.2651 99.5876 75.8805 99.5876 76.6326C99.5876 77.3847 98.9722 78.0001 98.2201 78.0001Z",
    fill: "#5630B5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBank);
export default __webpack_public_path__ + "static/media/bank.44b6a9748eec4ed04ae32de237644e53.svg";
export { ForwardRef as ReactComponent };